<script lang="ts">

export type Emits = {
  (e: "increase"): void;
  (e: "decrease"): void;
  (e: "reset"): void;
}
</script>
<script setup lang="ts">
import { defineEmits, defineComponent } from "vue";

const emit = defineEmits<Emits>();

defineComponent({
  name: 'PlusMinus',
})
</script>

<template>
  <div class="button-container">
    <button class="button-segment left" @click="emit('decrease')">-</button>
    <button class="button-segment middle" @click="emit('reset')">↺</button>
    <button class="button-segment right" @click="emit('increase')">+</button>
  </div>
</template>

<style scoped lang="scss">
.button-container {
  justify-content: center;
  align-items: center;

  .button-segment {
    padding: 5px 10px;
    font-size: 16px;
    border: 1px solid var(--border);
    background-color: var(--btn-bg);
    color: var(--text-primary);
    cursor: pointer;
    transition: background-color var(--transition-fast), color var(--transition-fast);

    &.left {
      border-top-left-radius: var(--radius-sm);
      border-bottom-left-radius: var(--radius-sm);
    }

    &.middle {
      border-left: none;
      border-right: none;
    }

    &.right {
      border-top-right-radius: var(--radius-sm);
      border-bottom-right-radius: var(--radius-sm);
    }
    &:active {
      background-color: var(--accent);
      color: #fff;
      border-color: var(--accent);
    }
    &:hover:not(:active) {
      background-color: var(--btn-hover-bg);
      color: var(--accent);
    }
  }
}
</style>